export default [
  {
    id: '96ac6f77-4ca7-449e-b15e-6986697ee5f9', // id 全局唯一，终身制
    name: 'sourceViewVulkan',
    path: '/source-view-vulkan',
    meta: { title: '模型预览5.0' },
    layout: 'fullscreen',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: 'f199c9ea-67cf-419a-88d7-218cd514f4bb',
        path: 'index',
        name: 'sourceViewVulkan',
        component(resolve) {
          require(['./views/index'], resolve)
        },
        meta: {
          title: '模型预览5.0',
          operations: {},
          hidden: true,
        },
      },
    ],
  },
]
